/**
 * The workspace's CMMD plan: entitlements and what is left of each metered
 * allowance, plus the per-day series behind it. Subscription consumption, which
 * the usage summary deliberately is not: that one estimates API-equivalent
 * value.
 *
 * A plan belongs to an organization. The Shell signs in as the user, so a read
 * that names none lands in the user's default organization, their personal
 * space. Pass the organization the user's Environment runs in; the proxy turns
 * `orgId` into `X-Organization-ID` (FOR-36406).
 *
 * @module environments/cmmdApi/billing
 */
import type { CmmdBillingContext, CmmdBillingSeries } from "@cmmd-forge/contracts";

import { request, type TransportConfig } from "./transport";

export interface BillingReadInput {
  readonly organizationId?: number;
}

export function fetchBilling(
  cfg: TransportConfig,
  input?: BillingReadInput,
): Promise<CmmdBillingContext> {
  return request<CmmdBillingContext>(
    {
      method: "GET",
      path: "/api/cmmd/billing",
      ...(input?.organizationId !== undefined ? { query: { orgId: input.organizationId } } : {}),
    },
    cfg,
  );
}

export function fetchBillingSeries(
  cfg: TransportConfig,
  input: { readonly timeZone: string },
): Promise<CmmdBillingSeries> {
  return request<CmmdBillingSeries>(
    { method: "GET", path: "/api/cmmd/billing/series", query: { timeZone: input.timeZone } },
    cfg,
  );
}
